import type { Tenant } from "@/modules/tenants/tenants.api";
import {
  pickReadableForegroundOn,
  pickReadablePrimaryOn,
} from "@/lib/theme/brand-contrast";

export function syncTenantBrandCssVars(tenant: Tenant | undefined): void {
  const root = document.documentElement;
  const brand = tenant?.brand?.brand_color?.trim();
  const sidebar = tenant?.brand?.sidebar_color?.trim();

  if (brand) {
    const primaryOnBrand = pickReadablePrimaryOn(brand);
    root.style.setProperty("--brand-color", brand);
    root.style.setProperty(
      "--brand-on-brand",
      pickReadableForegroundOn(brand),
    );
    root.style.setProperty(
      "--brand-primary-on-brand",
      primaryOnBrand.base,
    );
    root.style.setProperty(
      "--brand-primary-on-brand-hovered",
      primaryOnBrand.hovered,
    );
  } else {
    root.style.removeProperty("--brand-color");
    root.style.removeProperty("--brand-on-brand");
    root.style.removeProperty("--brand-primary-on-brand");
    root.style.removeProperty("--brand-primary-on-brand-hovered");
  }

  if (sidebar) {
    root.style.setProperty("--sidebar-color", sidebar);
    root.style.setProperty(
      "--sidebar-on-sidebar",
      pickReadableForegroundOn(sidebar),
    );
  } else {
    root.style.removeProperty("--sidebar-color");
    root.style.removeProperty("--sidebar-on-sidebar");
  }
}
